import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import { Wrapper, GridContainer, LoaderContainer } from './styled';

import Standard from '../strandard-item';
import PulseLoader from '../pulse-loader';
import EmptyState from '../empty-state';

/* eslint-disable */
let toggleStandardCollapse = null;

const Standards = ({ handleOnScroll, i18n }) => {
  /**
   * STORE
   */
  const selectedLearningJourneyIds = useSelector(state => state.UPFAssignReducer.selectedLearningJourneyIds);
  const selectedTopics = useSelector(state => state.UPFAssignReducer.selectedTopics, shallowEqual);
  const showGridLoader = useSelector(state => state.UPFAssignReducer.showGridLoader);
  const genericCourses = useSelector(state => state.UPFAssignReducer.genericCourses);
  const selectedClass = useSelector(state => state.UPFAssignReducer.selectedClass);
  const sortedStudents = useSelector(state => state.UPFAssignReducer.sortedStudents);
  const sortedStudentIds = useSelector(state => state.UPFAssignReducer.sortedStudentIds);
  const isLoadingGenericCourses = useSelector(state => state.UPFAssignReducer.isLoadingGenericCourses);

  /**
   * STATE
   */
  const [isStandardsCollapsed, setIsStandardsCollapsed] = useState(false);
  const [isStandardDirty, setIsStandardDirty] = useState(false);

  /**
   * FUNCTIONS
   */
  toggleStandardCollapse = collapsedState => {
    setIsStandardsCollapsed(collapsedState);
    setIsStandardDirty(false);
  };

  /**
   * Local variables
   */
  const studentsCount = sortedStudentIds.length;
  const showEmptyState = !selectedLearningJourneyIds.length && !studentsCount;

  /**
   * RENDER
   */
  if (showGridLoader || isLoadingGenericCourses) {
    return (
      <GridContainer>
        <LoaderContainer>
          <PulseLoader />
        </LoaderContainer>
      </GridContainer>
    );
  }

  if (showEmptyState) {
    return (
      <GridContainer>
        <LoaderContainer>
          <EmptyState i18n={i18n} />
        </LoaderContainer>
      </GridContainer>
    );
  }

  return (
    <Wrapper id="standards" onScroll={handleOnScroll}>
      {selectedTopics.map(topic =>
        topic.childTopics.map(childTopic => {
          if (!childTopic.selected) return null;

          return (
            <Standard
              key={childTopic.displayName}
              externalKey={childTopic.externalKey}
              learningJourney={childTopic.childTopics}
              topicName={childTopic.name}
              description={childTopic.description}
              id={childTopic.id}
              i18n={i18n}
              collapseAllStandards={isStandardsCollapsed}
              isStandardDirty={isStandardDirty}
              setIsStandardDirty={setIsStandardDirty}
              selectedClass={selectedClass}
              genericCourses={genericCourses}
            />
          );
        })
      )}
    </Wrapper>
  );
};

Standards.propTypes = {
  i18n: PropTypes.object,
  handleOnScroll: PropTypes.func
};

Standards.defaultProps = {
  handleOnScroll: () => {}
};

export { Standards, toggleStandardCollapse };



// WEBPACK FOOTER //
// ./components/standards/index.js